// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.input-container {
  display: flex;
  flex-direction: column;
}
.input-container .prop-label {
  font-family: "GothamBold", Arial, sans-serif;
  margin-bottom: 0.25rem;
}
.input-container .prop-label.required::after {
  color: #97002e;
  content: " *";
}
.input-container mat-form-field {
  width: 100%;
}

.disabled-input {
  cursor: not-allowed;
}

.inline-spinner {
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
